import pageConfig from '@/config/config.page.json';

export const checkForDefaultLocale = (locale: string) => {
  return locale === pageConfig.DEFAULT_LOCALE;
};
